const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/customisation/mailer/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type SiteSettings_Fragment$data } from '@/graphql/queries/SiteSettings.query';
import { createFileRoute } from '@tanstack/react-router';
import type { DeepWritable } from 'ts-essentials';
export const Route = createFileRoute('/dash/settings/customisation/mailer/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
type Mailer = DeepWritable<NonNullable<SiteSettings_Fragment$data['siteSettings']>['mailer']>;